<template>
    <div class="page">
        <div class="version-container">
            <!-- <div class="page-top"></div> -->
            <div class="titleBox" ref="titleBox">
                <p class="index-common_title tc">
                    版本下载
                </p>
                <p class="index-common_subtitle tc">
                    Download
                </p>
            </div>
            <div class="products" ref="products">
                <!-- <a class="item" title="Window版本" href="https://cdn.huashengdaili.com/huashengdaili1.3.0.exe">
                    <p class="text">Windows版本</p>
                    <div class="wechat">
                       <img src="~@/assets/img/index_img/download_icon_pc.png" alt="">
                       <p>PC端</p>
                       <button>立即下载</button>
                    </div>
                </a> -->
                <!-- 推广 -->
                <a class="item" title="Window版本" ref="pc" href="https://cdn.huashengdaili.com/huashengdaili_zdgs_1.4.5.exe">
                    <p class="text">Windows版本</p>
                    <div class="wechat">
                       <img src="~@/assets/img/index_img/download_icon_pc.png" alt="">
                       <p>PC端</p>
                       <button>立即下载</button>
                    </div>
                </a>

                <a class="item" title="iOS版本" target="_blank" ref="ios" href="https://itunes.apple.com/cn/app/%E8%8A%B1%E7%94%9F%E4%BB%A3%E7%90%86/id1367038214?mt=8">
                     <p class="text">iOS版本</p>
                     <div class="wechat">
                       <img src="~@/assets/img/index_img/ios_wechat.png" alt="">
                       <p>扫描二维码下载iOS端</p>
                       <button>立即下载</button>
                     </div>
                </a>
                <!-- <a class="item" title="Android版本" href="https://cdn.huashengdaili.com/earthnutproxy_huashengdaili_v1.0.20.apk">
                    <p class="text">Android版本</p>
                    <div class="wechat">
                       <img src="~@/assets/img/index_img/android_wechat.png" alt="">
                       <p>扫描二维码下载Android端</p>
                       <button>立即下载</button>
                     </div>
                </a> -->
                 <a class="item" title="Android版本" ref="android" href="https://cdn.huashengdaili.com/earthnutproxy_tiaozhuan_v1.0.37.apk">
                    <p class="text">Android版本</p>
                    <div class="wechat">
                       <img src="~@/assets/img/index_img/android_wechat.png" alt="">
                       <p>扫描二维码下载Android端</p>
                       <button>立即下载</button>
                     </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import doPost from "@/pages/Helper/XHR.js"
import Cookies from 'js-cookie'
export default {
  name: 'vsrsion',
  data () {
    return {
      type: '',
      channel1: 'huashengdaili',
      channel2: 'tiaozhuan'
    }
  },
  props: {
      version_animation: Boolean,
  },
  watch: {
    version_animation () {
      if(this.version_animation){
          this.$refs.titleBox.classList.add("titleBoxAn")
          this.$refs.products.classList.add("productsAn")
      }
    }
  },
  mounted () {
    this.download();
    this.productsLink();
  },
  methods: {
    download () {
      var items =  this.$refs.products.getElementsByClassName('item')
      var _this = this
      for(let i=0;i<items.length;i++){
        items[i].addEventListener('click',() => {
          if(items[i].innerHTML.match('Android')){
            this.type = 'android'
          }else if(items[i].innerHTML.match('Windows')){
            this.type = 'pc'
          }else{
            this.type = 'ios'
          }
          let promise = new Promise((resolve,reject) => {
              doPost(
              {action:'download', ip:returnCitySN["cip"], type:this.type, channel:this.channel2, keyword: Cookies.get('keyword')},
              (data) => {
                if(data.status==200){
                    console.log(data)
                    resolve(data)
                }
              }
            )
          })
          promise.then(function(data){
            console.log(_this)
            console.log(_this.type)
            if(data.status==200){
              doPost(
                {action:'download_keyword', ip:returnCitySN["cip"], domain: Cookies.get('domain'), type: _this.type, channel:_this.channel2, keyword: Cookies.get('keyword'), domain_keyword: `${Cookies.get('domain')}${Cookies.get('keyword')}` },
                (data) => {
                 console.log(data)
                }
              )
            }
          })
        })
      }
    },
    getVersion () {
      doPost({
        action: 'channel_download',
        channel: 'huashengdaili'
      },(res) => {
        console.log('自动更新最新版本')
        this.vaersion = res.data;
        let pc = document.getElementById('item_pc');
        pc.setAttribute('href', this.vaersion.pc);
        let ios = document.getElementById('item_ios');
        ios.setAttribute('href', this.vaersion.ios);
        let android = document.getElementById('item_android');
        android.setAttribute('href', this.vaersion.android);
      })
    },
    productsLink () {
      doPost({action: 'channel_download',channel: this.channel2},
        (res) => {
          if(res.status == '200'&&res.detail) {
            let data = res.data;
            let pc = data.pc ? data.pc : '';
            let ios = data.ios ? data.ios : '';
            let android = data.android ? data.android : '';
            if(pc) {
              this.$refs.pc.href = pc;
              console.log(this.$refs.pc.href)
              localStorage.setItem('pc',this.$refs.pc.href)
            }
            if(ios) {
              this.$refs.ios.href = ios;
              console.log(this.$refs.ios.href)
              localStorage.setItem('ios',this.$refs.ios.href)
            }
            if(android) {
              this.$refs.android.href = android;
              console.log(this.$refs.android.href)
              localStorage.setItem('android',this.$refs.android.href)
            }
          }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
    .version-container
        position:relative;
    .version-container .titleBox
        transform translateY(-100px)
        opacity 0
        transition all 1s ease
    .version-container .titleBoxAn
        transform:translateY(0px)
        opacity 1
    .version-container .products
        display flex
        justify-content center
        margin-bottom 2rem
        transition all .56s ease
        transform:translateY(100px)
        opacity 0
        width 1200px
        margin 0 auto
    .version-container .productsAn
        transform:translateY(0px)
        opacity 1
    .version-container .products .item
        width 7.9rem
        height 220px
        background #32bf99
        border-radius 10px
        margin 0rem .1rem
        cursor pointer
        display inline-block
        background-position center 30%
        background #393B3A
        background-position center 30%
        position relative
        .wechat
          text-align center
          position absolute
          width 100%
          height 100%
          opacity 0
          top 0
          left 0
          background #2BD3A0
          border-radius 10px
        .wechat img
          width 118px
          height 118px
          margin-top 15px
          cursor default
        .wechat p
          margin-top 8px
          color #000
         .wechat button
          margin-top 6px
          height 38px
          width 195px
          background: #FFFFFF;
          box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
          border-radius: 100px;
          color: #2BD3A0;
          cursor pointer
     .version-container .products .item:hover
        animation rock 1s ease-in-out
        animation-delay 0.2s
        animation-iteration-count 2
        animation-direction alternate
    .version-container .products .item:nth-child(1)
        background-image url("~@/assets/img/index_img/2_icon_windows_normal.png")
        background-repeat no-repeat
        &:hover .wechat
          opacity 1
    .version-container .products .item:nth-child(2)
        background-image url("~@/assets/img/index_img/2_icon_ios_normal.png")
        background-repeat no-repeat
        &:hover .wechat
          opacity 1
    .version-container .products .item:nth-child(3)
        background-image url("~@/assets/img/index_img/2_icon_android_normal.png")
        background-repeat no-repeat
        &:hover .wechat
          opacity 1
    .version-container .products .item .text
        text-align center
        margin-top 3rem
        color #fff
        font-size 16px
    @media screen and (max-width: 1200px)
        .version-container .products
            width auto
            margin auto
    @media (min-width: 758px) and (max-width: 946px)
        .version-container .products .item
            margin 0rem .2rem
            height 4rem
    @media screen and (max-width: 758px)
        .version-container .products
            display inherit
            text-align center
            margin-bottom .56rem
        .version-container .products .item
            height 70px
            width 200px
            margin 0rem
            margin-bottom .2rem
            display inline-block
            background-position center 23%
            background-size 20% 50%
            display block
            margin 0 auto
        .version-container .products .item .wechat
            display none
        .version-container .products .item .text
            margin-top .3rem
            font-size 16px
            padding-top 36px
    @media screen and (max-width: 456px)
        .version-container .products .item
            background #4facfe
            display inline-block
            background-position center 23%
            background-size 20% 50%
            display block
            margin 0 auto
        .version-container .products .item .text
            padding-top 50px
    @keyframes rock{
        0%{
            transform: rotate(0deg);
        }
        10%{
            transform: rotate(3deg);
        }
        20%{
            transform: rotate(-3deg);
        }
        30%{
            transform: rotate(2deg);
        }
        40%{
            transform: rotate(-2deg);
        }
        50%{
            transform: rotate(1deg);
        }
        60%{
            transform: rotate(-1deg);
        }
        70%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(0deg);
        }
    }
</style>





// WEBPACK FOOTER //
// src/pages/Home/components/version.vue